import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { CandidateStatus } from '../../common/enums/CandidateStatus';
import { ICandidateUpdateStatus } from '../../common/models/candidate/ICandidateUpdateStatus';
import { IBindingAction, IBindingCallback1 } from '../../common/models/callback';
import ModalWindow from '../../components/ModalWindow';
import RegularButton from '../../components/RegularButton';
import { updateCandidateStatusRoutine } from '../CandidatesBulkActions/routines';
import styles from './styles.module.scss';

interface IArchiveCandidateModalProps {
  candidates: string[];
  isShown: boolean;
  onHide: IBindingAction;
  updateCandidateStatus: IBindingCallback1<ICandidateUpdateStatus>;
}

const ArchiveCandidateModal: FunctionComponent<IArchiveCandidateModalProps> = ({
  isShown,
  candidates,
  onHide,
  updateCandidateStatus
}) => {
  const archive = (status: CandidateStatus) => {
    updateCandidateStatus({ status, ids: candidates });
    onHide();
  };

  return (
    <ModalWindow
      isShown={isShown}
      onHide={onHide}
      contentClassName="small-modal"
    >
      <div onClick={e => e.stopPropagation()} role="presentation" className={styles.archiveModal}>
        <div className="custom-modal-header">
          <FormattedMessage id="bulkActions.archiveCandidates" defaultMessage="Archive candidate(s)" />
        </div>
        <div className={styles.archiveBody}>
          <FormattedMessage
            id="bulkActions.archiveDescr"
            defaultMessage="Were the selected candidates hired or not hired?"
          />
        </div>
        <div className={styles.archiveFooter}>
          <RegularButton
            textIntlId="hired"
            defaultMessage="Hired"
            variant="secondary"
            onClick={() => archive(CandidateStatus.InactiveHired)}
            size="lg"
          />
          <RegularButton
            textIntlId="notHired"
            defaultMessage="Not Hired"
            variant="secondary"
            onClick={() => archive(CandidateStatus.InactiveHibernate)}
            size="lg"
          />
        </div>
      </div>
    </ModalWindow>
  );
};

const mapDispachToProps = {
  updateCandidateStatus: updateCandidateStatusRoutine
};

export default connect(null, mapDispachToProps)(ArchiveCandidateModal);
